// import React, { useState, useEffect } from "react";
// import * as Sentry from "@sentry/react";
// // importing the css
// import css from "../../style/visionStyle.module.css";
// // importing components
// import { Modal, Box } from "@material-ui/core";
// import { Elements } from "@stripe/react-stripe-js";
// import PaymentForm2 from "../stripe/PaymentForm2";
// import { bookingIfCardSaved } from "../../store/actions/paymentActions";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router";
// import { updateBooking } from "../../store/actions/bookingActions";
// import { stripeTestPromise } from "../../store/constants/baseUrl";
// import ModalComponent from "../Modals/Modal";

// const PaymentScreen = ({
//   id,
//   type,
//   userInfo,
//   setShowLottie,
//   setShowPaymentMessage,
//   handleUpdateBookingObject

// }) => {
//   // dispatch redux actions
//   const dispatch = useDispatch();
//   // history for routing
//   const history = useNavigate();
//   // state to restrict multipel clicks
//   const [buttonClicked, setButtonClicked] = useState(false);
//   // State to open CC modal
//   const [openCreditCardModal, setopenCreditCardModal] = useState(false);
//   // State to open CC response modal
//   const [openCreditCardResponseModal, setopenCreditCardResponseModal] =
//     useState(false);

//   // State to open Booking error modal
//   const [openBookingErrorModal, setopenBookingErrorModal] = useState(false);
//   //toggle for card window name
//   const [firstNameToggle, setfirstNameToggle] = useState(true);
//   //payment credentials
//   const [fullName, setfullName] = useState("");
//   const [bookNowClicked, setBookNowClicked] = useState(false);

//   const toggleLoading = (val) => {
//     setShowLottie(val);
//     setShowPaymentMessage(val);
//   };
//   // function to close CC modal
//   const handleCloseCardModal = () => {
//     try {
//       setopenCreditCardModal(false);
//       setfirstNameToggle(true);
//     } catch (error) {
//       Sentry.captureException(error);
//       console.log(error);
//     }
//   };

//   //form ID control
//   const [formID, setformID] = useState("");
//   // function to place order and make payment
//   const handlePlaceOrder = () => {
//     setBookNowClicked(true);
//     handleCloseCardAddedModal();
//     let user = localStorage.getItem("wemoovezUserProfile");
//     if (!user) {
//       history("/Login");
//       return;
//     }
//     user = JSON.parse(user);
//     try {
//       if (user?.hasCard) {
//         setShowLottie(true);
//         setShowPaymentMessage(true);
//         dispatch(
//           bookingIfCardSaved(
//             id,
//             type,
//             history,
//             toggleLoading,
//             handleShowBookingErrorModal,
//             3
//           )
//         );
//       } else {
//         setopenCreditCardModal(true);
//         setBookNowClicked(false);
//       }
//     } catch (error) {
//       Sentry.captureException(error);
//       console.log(error);
//       toggleLoading(false);
//     }
//   };

//   const handleShowCardAddedModal = () => {
//     setopenCreditCardResponseModal(true);
//   };

//   const handleCloseCardAddedModal = () => {
//     setopenCreditCardResponseModal(false);
//   };

//   const handleShowBookingErrorModal = () => {
//     setopenBookingErrorModal(true);
//   };

//   const handleCloseBookingErrorModal = () => {
//     setopenBookingErrorModal(false);
//   };

//   //Modal styles
//   const style = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 400,
//     bgcolor: "background.paper",
//     border: "2px solid #000",
//     boxShadow: 24,
//     p: 4,
//   };

//   useEffect(() => {
//     try {
//       let makeBtnClickable;

//       if (buttonClicked) {
//         makeBtnClickable = setTimeout(() => {
//           setButtonClicked(false);
//         }, 10000);
//       }
//       return () => clearTimeout(makeBtnClickable);
//     } catch (error) {
//       Sentry.captureException(error);
//       console.log(error);
//     }
//   }, [buttonClicked]);

//   useEffect(() => {
//     try {
//       let makeBookNowBtnClickable;

//       if (bookNowClicked) {
//         makeBookNowBtnClickable = setTimeout(() => {
//           setBookNowClicked(false);
//         }, 10000);
//       }
//       return () => clearTimeout(makeBookNowBtnClickable);
//     } catch (error) {
//       Sentry.captureException(error);
//       console.log(error);
//     }
//   }, [bookNowClicked]);



//   return (
//     <div>
//       <ModalComponent
//         text={
//           "Card added successfully, click request now to proceed with your booking."
//         }
//         openState={openCreditCardResponseModal}
//         closeFunction={handleCloseCardAddedModal}
//         btnText1={"Request now"}
//         btnClickFunc1={handlePlaceOrder}
//         btnText2={"Close"}
//         btnClickFunc2={handleCloseCardAddedModal}
//       />
//       <ModalComponent
//         text={"Something went wrong, please try again or contact our support."}
//         openState={openBookingErrorModal}
//         closeFunction={handleCloseBookingErrorModal}
//         btnText1={"Contact Us"}
//         btnClickFunc1={() => history("/ContactUs")}
//         btnText2={"Close"}
//         btnClickFunc2={handleCloseBookingErrorModal}
//       />
//       <div>
//         <Modal
//           open={openCreditCardModal}
//           onClose={handleCloseCardModal}
//           aria-labelledby="modal-modal-title"
//           aria-describedby="modal-modal-description"
//         >
//           <Box className="w-[50%] my-[10vh] mx-auto bg-white rounded-[10px] p-[30px] outline-none">
//             <div className="text-[#8b84c6] uppercase font-extralight text-[12.8px]">
//               Payment Process
//             </div>
//             <div className="text-[var(--primary)] capitalize text-[32px] font-normal">
//               Checkout Details
//             </div>
//             <div className="text-[14.4px] my-[20px] text-[#808080]">
//               Please add a payment method so we can pair your job to a moover.
//               Charges apply only after your job has been successfully completed.
//               This is a secure AES-256 encrypted payment.
//             </div>
//             <div className="w-full p-[20px] my-[10px] bg-white text-[#808080] rounded-[10px] shadow-[1px_1px_3px_rgba(0,0,0,0.75)]">
//               {firstNameToggle ? (
//                 <span className="font-light">
//                   {fullName
//                     ? fullName
//                     : userInfo?.firstName + " " + userInfo?.lastName}
//                 </span>
//               ) : (
//                 <input
//                   value={fullName}
//                   onChange={(e) => setfullName(e.target.value)}
//                   className="w-[80%] focus:outline-none focus:border-none"
//                 ></input>
//               )}
//               <span
//                 className="ml-[5px] cursor-pointer"
//                 onClick={() => setfirstNameToggle(!firstNameToggle)}
//               >
//                 <i class="far fa-edit"></i>
//               </span>
//             </div>
//             <div className="w-full p-[20px] my-[10px] bg-white text-[#808080] rounded-[10px] shadow-[1px_1px_3px_rgba(0,0,0,0.75)]">
//               <Elements stripe={stripeTestPromise}>
//                 <PaymentForm2
//                   userId={userInfo?.id}
//                   // bookingId={id}
//                   // type={type}
//                   handleCloseCardModal={handleCloseCardModal}
//                   handleShowCardAddedModal={handleShowCardAddedModal}
//                   handleShowBookingErrorModal={handleShowBookingErrorModal}
//                   setShowLottie={toggleLoading}
//                   submitWrapper={(cb, e) => {
//                     e.preventDefault();
//                     if (!buttonClicked) {
//                       toggleLoading(true);
//                       setButtonClicked(true);
//                       cb(e);
//                     }
//                   }}
//                 />
//               </Elements>
//             </div>
//             <div className="flex justify-end font-bold">
//               <button
//                 onClick={handleCloseCardModal}
//                 className="bg-transparent text-[var(--primary)] rounded-[20px] w-[100px] h-[40px] border-[2px] border-[var(--primary)] font-bold flex items-center justify-center"
//                 style={{ marginRight: 10 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 form={formID}
//                 onClick={() => {
//                   try {
//                     setformID("payment-in-booking");
//                   } catch (error) {
//                     Sentry.captureException(error);
//                     console.log(error);
//                   }
//                 }}
//                 className="bg-[var(--primary)] rounded-[20px] w-[150px] h-[40px] text-white font-bold mr-[5px] flex items-center justify-center"
//               >
//                 Add card
//               </button>
//             </div>
//           </Box>
//         </Modal>

//         <button
//           onClick={bookNowClicked ? () => {} : handlePlaceOrder}
//           className="w-full h-[48px] rounded-[15px] font-semibold text-[16px] text-white bg-gradient-to-b from-[#55AB26] to-[#8EDA65]"
//         >
//           Book now BUtton
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PaymentScreen;


import React from 'react'

const PaymentScreen = () => {
  return (
    null
  )
}

export default PaymentScreen




